const mutations = {
    setLoading(state, status) {
        state.isLoading = status;
    },

    setInView(state, entry) {
        state.inView = entry;
    },

    setCache(state, payload) {
        state.cache[payload.post_id] = payload.data;
    },

    setPrevNext(state, payload) {
        state.previous = payload.prev;
        state.next = payload.next;
    }
};

export default mutations;